import { useEffect } from 'preact/hooks';
import { useGameContextMenu } from './hooks/use-game-context-menu';
import { useObservable } from './hooks/use-observable';
import { useTranslator } from './hooks/use-translator';
import { currentGame, preloadGame } from './screens/game-screen-loader';
import { CharacterSelectScreen } from './screens/character-select';
import { SignInScreen } from './screens/sign-in';
import { SessionEndedScreen } from './screens/session-ended';
import { ServicesProvider, useBoot } from './services';

/** Top-level router: the session phase decides which screen is shown. */
export function App() {
  const { session: client } = useBoot();
  const translator = useTranslator();
  const session = useObservable(client.phase);
  useGameContextMenu();
  // The game comes in its own chunk, preloaded once the first screen showed (NET-CLIENT-CACHE
  // C3): by the time a character is chosen it is here, and the renderer too.
  useEffect(() => {
    preloadGame();
  }, []);

  switch (session.phase) {
    case 'signed_out':
      return <SignInScreen error={session.error} />;
    case 'account':
      return <CharacterSelectScreen />;
    case 'restoring':
    case 'active': {
      // A character is active only once the game was made for it.
      const game = session.phase === 'active' ? currentGame() : null;
      if (session.phase === 'active' && game) {
        return (
          <ServicesProvider services={game.services}>
            <game.Screen player={session.player} />
          </ServicesProvider>
        );
      }
      return (
        <main class="screen screen--centered">
          <p class="muted">{translator.t('common.loading')}</p>
        </main>
      );
    }
    case 'ended':
      return <SessionEndedScreen reason={session.reason} />;
  }
}
